var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrameArrow2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 36,
    viewBox: "0 0 248 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M247 33.5C216.028 3.50111 70.5 -21.5004 3.5 32.4998",
    stroke: "#8E93A2",
    strokeOpacity: 0.76,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.856949 33.434C2.58586 32.2597 3.7489 30.3992 5.29159 28.9997",
    stroke: "#8E93A2",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.10327 33.3025C1.49047 33.5244 3.46773 32.9844 3.78248 32.9495C5.48775 32.7608 7.05532 32.5607 8.68894 32.0898",
    stroke: "#8E93A2",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrameArrow2);
export default __webpack_public_path__ + "static/media/frame-arrow-2.2b39d6fdc19b509ef5990efe6ef1f24d.svg";
export { ForwardRef as ReactComponent };